import React, { createContext, useContext, useState, useRef, useCallback } from 'react';
import ConfirmModal from '../components/ConfirmModal';

const ConfirmContext = createContext(null);

export const ConfirmProvider = ({ children }) => {
  const [modalState, setModalState] = useState(null);
  const resolverRef = useRef(null);

  const confirm = useCallback((options) => {
    let opts = options;
    if (typeof options === 'string') {
      opts = {
        message: options,
        title: 'Confirmação',
        type: 'danger'
      };
    }

    return new Promise((resolve) => {
      resolverRef.current = resolve;
      setModalState({
        title: opts.title || 'Confirmação',
        message: opts.message || 'Tem certeza que deseja prosseguir?',
        detail: opts.detail || null,
        confirmText: opts.confirmText,
        cancelText: opts.cancelText || 'Cancelar',
        type: opts.type || 'danger',
        isAlert: false
      });
    });
  }, []);

  const showAlert = useCallback((options) => {
    let opts = options;
    if (typeof options === 'string') {
      opts = {
        message: options,
        title: 'Aviso',
        type: 'warning'
      };
    }

    return new Promise((resolve) => {
      resolverRef.current = resolve;
      setModalState({
        title: opts.title || 'Aviso',
        message: opts.message || '',
        detail: opts.detail || null,
        confirmText: opts.confirmText || 'Entendi',
        cancelText: '',
        type: opts.type || 'warning',
        isAlert: true
      });
    });
  }, []);

  const handleConfirm = useCallback(() => {
    if (resolverRef.current) {
      resolverRef.current(true);
      resolverRef.current = null;
    }
    setModalState(null);
  }, []);

  const handleCancel = useCallback(() => {
    if (resolverRef.current) {
      resolverRef.current(false);
      resolverRef.current = null;
    }
    setModalState(null);
  }, []);

  return (
    <ConfirmContext.Provider value={{ confirm, showAlert }}>
      {children}
      {modalState && (
        <ConfirmModal
          isOpen={true}
          title={modalState.title}
          message={modalState.message}
          detail={modalState.detail}
          confirmText={modalState.confirmText}
          cancelText={modalState.cancelText}
          type={modalState.type}
          isAlert={modalState.isAlert}
          onConfirm={handleConfirm}
          onCancel={handleCancel}
        />
      )}
    </ConfirmContext.Provider>
  );
};

export const useConfirm = () => {
  const context = useContext(ConfirmContext);
  if (!context) {
    throw new Error('useConfirm deve ser utilizado dentro de um ConfirmProvider');
  }

  const confirmFn = (options) => context.confirm(options);
  confirmFn.confirm = context.confirm;
  confirmFn.alert = context.showAlert;

  return confirmFn;
};

export const useAlert = () => {
  const context = useContext(ConfirmContext);
  if (!context) {
    throw new Error('useAlert deve ser utilizado dentro de um ConfirmProvider');
  }
  return context.showAlert;
};

export default ConfirmContext;
